import LoadingDots from '../LoadingDots';
import PropTypes from 'prop-types';
import React from 'react';

type LoadingScreenProps = {
  title?: string,
  description?: string
};

const LoadingScreen: React.FC<LoadingScreenProps> = ({ title, description }) => {
  return <div className="tw-fixed tw-h-screen tw-w-full tw-top-0 tw-bottom-0 tw-left-0 tw-right-0 tw-bg-white" style={{ zIndex: 1099 }}>
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-w-full tw-h-full">
      <div className={title ? "tw-mb-4" : ""}>
        <LoadingDots size="xl" />
      </div>
      {
        title &&
        <span className="tw-block tw-text-lg">
          {title}
        </span>
      }
      {
        description &&
        <span>{description}</span>
      }
    </div>
  </div>;
};

LoadingScreen.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string
};

export default LoadingScreen;
